import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { FAQS } from "@/data/content";
import { Reveal } from "@/components/site/reveal";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="bg-bone pb-24 pt-8 md:pb-32" data-testid="faq-section">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 lg:grid-cols-12 lg:px-10">
        <div className="lg:col-span-4">
          <Reveal><p className="text-[11px] uppercase tracking-[0.3em] text-gold font-semibold">FAQ</p></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-serif text-4xl leading-tight text-navy sm:text-5xl">
              Questions,<br />answered.
            </h2>
          </Reveal>
        </div>

        <div className="lg:col-span-8">
          <div className="border-t border-navy/10">
            {FAQS.map((f, i) => {
              const isOpen = openIdx === i;
              return (
                <div key={i} className="border-b border-navy/10" data-testid={`faq-item-${i}`}>
                  <button
                    onClick={() => setOpenIdx(isOpen ? -1 : i)}
                    data-testid={`faq-trigger-${i}`}
                    className="flex w-full items-center justify-between gap-6 py-7 text-left"
                  >
                    <span className="font-serif text-xl text-navy md:text-2xl">{f.q}</span>
                    <Plus className={`h-5 w-5 shrink-0 text-gold transition-transform duration-300 ${isOpen ? "rotate-45" : ""}`} />
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                        className="overflow-hidden"
                      >
                        <p className="max-w-xl pb-7 text-base leading-relaxed text-navy/60">{f.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
